import { random, round2Str } from "../helpers/helpers";
import { thMeterSensorRegistry } from "./thMeterSensorRegistry";

export const generateThChartYearlyDemo = ({
                                              meter_id,
                                              sensor_name, // sensor_id
                                              year,
                                          }) => {
    const now = new Date();
    const currentYear = now.getFullYear();
    const currentMonth = now.getMonth() + 1; // 1–12

    const isCurrentYear = Number(year) === currentYear;
    const maxMonth = isCurrentYear ? currentMonth : 12;

    // -------------------------
    // Resolve sensor from registry
    // -------------------------
    const meterEntry = thMeterSensorRegistry.find(
        (m) => m.meter_id === Number(meter_id)
    );

    const sensorEntry = meterEntry?.sensors.find(
        (s) => s.sensor_id === Number(sensor_name)
    );

    const [minTempRange, maxTempRange] =
    sensorEntry?.temp_range || [20, 26];
    const [minHumiRange, maxHumiRange] =
    sensorEntry?.humi_range || [45, 60];

    // Base values (stable across months)
    let baseTemp = random(minTempRange + 1, maxTempRange - 1);
    let baseHumi = random(minHumiRange + 3, maxHumiRange - 3);

    const monthly_energy_data = [];

    for (let month = 1; month <= maxMonth; month++) {
        // -------------------------
        // Seasonal drift (less fake)
        // -------------------------
        const seasonalTempShift =
            Math.sin(((month - 1) / 12) * Math.PI * 2) * 2;

        const avgTemp = baseTemp + seasonalTempShift + random(-0.5, 0.5);
        const maxTemp = avgTemp + random(3, 6);
        const minTemp = avgTemp - random(3, 6);

        const avgHumi = baseHumi + random(-2, 2);
        const maxHumi = avgHumi + random(6, 10);
        const minHumi = avgHumi - random(6, 10);

        monthly_energy_data.push({
            month,

            avg_temp: round2Str(avgTemp),
            max_temp: round2Str(Math.min(maxTemp, maxTempRange + 3)),
            min_temp: round2Str(Math.max(minTemp, minTempRange - 3)),

            avg_humidity: round2Str(avgHumi),
            max_humidity: round2Str(
                Math.min(maxHumi, maxHumiRange + 10)
            ),
            min_humidity: round2Str(
                Math.max(minHumi, minHumiRange - 10)
            ),
        });
    }

    return {
        year: Number(year),
        monthly_energy_data,
    };
};
